module.exports = __webpack_public_path__ + "static/media/component1.181e8d70.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/qci/sprites/gameRocketRepair/component1.png
// module id = 2405
// module chunks = 0